import React from "react";
import { HiArrowUturnRight } from "react-icons/hi2";
import "./Instructions.scss";

type InstructionsProps = {
  setPage: React.Dispatch<React.SetStateAction<"CALCULATOR" | "INSTRUCTIONS">>;
};

export function Instructions({ setPage }: InstructionsProps) {
  return (
    <div className="eos-instructions">
      <div className="eos-instructions__actions">
        <button
          type="button"
          className="eos-back-button"
          onClick={() => setPage("CALCULATOR")}
        >

          {/* Rounded arrow icon (matches design) */}
          <HiArrowUturnRight
            className="eos-back-button__icon"
            aria-hidden="true"
          />

          <span className="eos-back-button__text">חזרה לתוצאות</span>
        </button>
      </div>

      <h4 className="subpage-header">
        התנהלות עם ילוד עם גורמי סיכון לזיהום ללא תסמינים קליניים
      </h4>

      <ul>
        <li>
          יש להשתמש לצורך החלטה על הבירור והטיפול במחשבון EOS. ובכל מקרה יש לציין
          את ערך הסיכון המשוקלל בגיליון היילוד.
        </li>

        <li>
          בלידת תאומים שלאחד מהם נצפתה קליניקה או צמיחת חיידק בדם / נוזל שדרה יילקח
          בירור ספסיס גם לתאום השני. יש לשקול מתן טיפול אמפירי בהתייעצות עם רופא
          נאונטולוג בהתאם לפרטי המקרה.
        </li>

        <li>
          יוצא מהכלל: ילוד שלאמו במהלך הלידה היה חום 39.0 מעלות ומעלה. במקרים
          אלו יילקח לתינוק בירור ספסיס חלקי ויינתן טיפול אנטיביוטי אמפירי בלי קשר
          להערכה במחשבון.
        </li>

        <li>
          ההחלטה על לקיחת בירור חלקי/מלא לספסיס והתחלת טיפול אנטיביוטי תילקח בהתאם
          להמלצת המחשבון בהתחשב למצב הקליני של התינוק.
        </li>
      </ul>

      <h4 className="subpage-header">התנהלות עם היילוד המציג תסמיני מחלה</h4>

      <ul>
        <li>
          בילוד עם תסמינים המחשידים לזיהום יש לבצע בירור זיהומי ולהתחיל בטיפול
          אנטיביוטי אמפירי. הבירור הזיהומי כולל: תרבית דם, ספירת דם, וצילום חזה
          (במקרה של תסמינים נשימתיים).
        </li>

        <li>
          גורמי הסיכון: פגות / הריון עודף, חום אימהי, ירידת מי שפיר ממושכת, נשאות
          GBS אימהית, כוריאואמניוניטיס אימהי.
        </li>

        <li>
          בילוד עם חשד קליני ל-Transient Tachypnea of the Newborn ניתן לדחות את
          ההחלטה לגבי בירור וטיפול באנטיביוטיקה לפי שיקול דעת והתייעצות עם רופא
          בכיר.
        </li>

        <li>
          ההחלטה על ביצוע LP תילקח בהתאם לקליניקה של התינוק בדיון עם רופא בכיר.
        </li>
      </ul>

      <h4 className="subpage-header">הטיפול האנטיביוטי</h4>

      <ul>
        <li>
          הכיסוי האמפירי השגרתי הוא באמפיצילין במינון 50 מ&quot;ג/ק&quot;ג פעמיים ביום
          וגנטמיצין בהתאם להוראות ה-NeoFax ובהתאמה לגיל ההיריון.
        </li>

        <li>
          במקרה של צמיחת חיידק בתרבית יש לבצע שינוי בטיפול לפי רגישות החיידק
          לאנטיביוטיקה.
        </li>

        <li>
          בילוד עם בדיקה גופנית תקינה והיעדר צמיחה בתרבית הדם ניתן לשקול בהיוועצות
          עם ניאונטולוג הפסקת טיפול האנטיביוטי כבר אחרי 36 שעות.
        </li>
      </ul>
    </div>
  );
}